import { useContext } from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { ticketDetailsContext, messageSaveSchema } from '../../TicketDetailsContext';
import { Form, Formik } from 'formik';
import { CircleLoader } from 'components';
import MessageEditor from './MessageEditor';
import Message from './Message';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';


let Messages = () => {
    let { formatMessage } = useIntl();

    let service = useContext(ticketDetailsContext);


    return (
        <Grid container>
            {service.isLoadingTicketMessages && <CircleLoader />}
            {service.isLoadingTicketMessages === false &&
                <Grid item xs={12}>
                    {service.ticket.isReadOnly === false &&
                        <Formik
                            validationSchema={messageSaveSchema}
                            initialValues={messageSaveSchema.getDefault()}
                            onSubmit={async (values, actions) => {
                                await service.saveMessage(values);
                                actions.setSubmitting(false);
                                actions.resetForm();
                            }}
                        >
                            <Form>
                                <Card>
                                    <CardContent>
                                        <MessageEditor ticketNumber={service.ticket.ticketNumber} />
                                    </CardContent>
                                </Card>
                            </Form>
                        </Formik>
                    }

                    {service.messages.length === 0 &&
                        <Typography variant="subtitle2">{formatMessage({ id: LocalizationIds.NoMessagePresent })}</Typography>
                    }
                    {service.messages.map((message) =>
                        <Message key={message.messageId} message={message} />
                    )}
                </Grid>
            }
        </Grid>
    )
}

export default Messages;